<template>
  <div class="container">
    <b-card class="card col-sm-12 col-lg-6  mx-auto">
      <b-card-body>
        <b-form>
          <h1>{{ $trans.main.auth_header }}</h1>
          <b-alert
            class="alert alert-danger"
            closeButton
            :show="errors"
          >
            {{ error }}
          </b-alert>
            <b-input
              class="form-control mb-3"
              :placeholder="trans.main.login"
              v-model="login"
              v-on:keyup.enter="focusPasswordInput"
            />
          <b-input
            class="form-control mb-3"
            :placeholder="trans.main.password"
            type="password"
            id="input_password"
            autocomplete="curent-password"
            v-model="password"
            v-on:keyup.enter="auth"
          >
          </b-input>
        </b-form>
        <b-form-row>
          <b-col>
            <b-button class="px-4 mb-4 w-100 btn-success" @click="auth">{{ trans.main.button_login }}</b-button>
          </b-col>
        </b-form-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {AUTH_REQUEST} from '../../store/actions'
import trans from '@/language/de'

export default {
  name: 'Login',
  data () {
    return {
      login: '',
      password: '',
      errors: false,
      error: '',
      trans: trans
    }
  },
  mounted () {
  },
  methods: {
    focusPasswordInput () {
      document.getElementById('input_password').focus()
    },
    auth: function () {
      this.errors = false
      const {login, password} = this
      this.$store.dispatch(AUTH_REQUEST, {login, password}).then((resp) => {
        this.$router.push('/')
      }).catch(err => {
        this.error = err
        this.errors = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/Login.vue